import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import i18n from './i18n'
import './styles/globals.css'

import { config } from 'md-editor-v3'
import { EditorView } from '@codemirror/view'
import { Prec } from '@codemirror/state'
import mermaid from 'mermaid'
import { torcazaMermaidConfig } from './config/mermaidTheme'

// Al pegar texto con imágenes markdown, md-editor-v3 inserta el texto y luego
// selecciona `text.length` caracteres. Si el texto trae saltos \r\n (Word,
// Windows, Google Docs), CodeMirror los normaliza a \n, el documento queda más
// corto y la selección cae fuera → "RangeError: Selection points outside of
// document". Normalizamos los saltos antes de que md-editor procese el pegado.
const normalizeCrlfPaste = Prec.highest(
  EditorView.domEventHandlers({
    paste(event, view) {
      const text = event.clipboardData?.getData('text/plain')
      if (!text || !text.includes('\r') || event.clipboardData?.files.length) return false
      event.preventDefault()
      view.dispatch(view.state.replaceSelection(text.replace(/\r\n?/g, '\n')), {
        scrollIntoView: true,
        userEvent: 'input.paste',
      })
      return true
    },
  })
)

// md-editor-v3 solo llama a mermaid.initialize (y aplica `mermaidConfig`) cuando
// cambia de tema claro/oscuro; con instancia propia nunca lo hace al arrancar.
// Sin esto, los diagramas dentro del documento salen con el tema por defecto.
mermaid.initialize(torcazaMermaidConfig)

config({
  editorExtensions: {
    mermaid: {
      instance: mermaid
    }
  },
  // Tema Torcaza para los diagramas (reemplaza el tema por defecto de md-editor)
  mermaidConfig: (base) => ({ ...base, ...torcazaMermaidConfig }),
  codeMirrorExtensions: (extensions) => [
    ...extensions,
    { type: 'normalizeCrlfPaste', extension: normalizeCrlfPaste },
  ],
})

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)

app.mount('#app')
